export default __webpack_public_path__ + "static/media/card-product1.6f4997ce.jpg";